import template from './avatar.template.html';

export default {
  template,
  bindings: {
    name: '<',
    tip: '<',
    avatar: '<',
    account: '<',
    organization: '<',
    contact: '<',
    initials: '<',
    fallback: '<',
    tooltip: '<',
    enforce: '<',
    override: '<',
    decache: '<',
    listen: '<'
  },
controller: class controller {
    constructor(distillerService, eventService, Account, Organization, Contact) {
      'ngInject';

      const ctrl = this;
      ctrl.destroyWatchAvatar = null;
      ctrl.destroyWatchLogo = null;
      ctrl.currentName = '';
      ctrl.currentInitials = '';
      ctrl.currentAvatar = '';

      ctrl.setAvatar = function (avatar) {
        if (avatar && avatar !== '') {
          return avatar + (ctrl.useDecaching ? `?decache=${new Date().getTime()}` : '');
        }
        return ctrl.useFallback
          ? ctrl.fallback
          : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      };

      this.$onInit = function () {
        ctrl.useInitials = ctrl.initials !== undefined ? ctrl.initials : true;
        ctrl.useFallback = ctrl.fallback !== undefined;
        ctrl.useTooltip = ctrl.tooltip !== undefined ? ctrl.tooltip : false;
        ctrl.useDecaching = ctrl.decache !== undefined ? ctrl.decache : false;
        ctrl.useEnforcement = ctrl.enforce !== undefined ? ctrl.enforce : false;
        ctrl.useOverride = ctrl.override !== undefined ? ctrl.override : false;

        if (ctrl.name) {
          ctrl.currentName = ctrl.name;
          ctrl.currentInitials = distillerService.getInitials(ctrl.name);
          ctrl.currentAvatar = ctrl.setAvatar(ctrl.avatar);
          ctrl.currentTip = ctrl.tip;
        } else if (ctrl.account) {
          ctrl.currentAccount =
            ctrl.account instanceof Account ? ctrl.account : Account.build(ctrl.account);
          ctrl.currentName = ctrl.currentAccount.getName();
          ctrl.currentInitials = distillerService.getInitials(ctrl.currentName);
          ctrl.currentAvatar = ctrl.setAvatar(ctrl.currentAccount.getAvatar());
          ctrl.currentTip = ctrl.tip !== undefined ? ctrl.tip : ctrl.currentName;
        } else if (ctrl.contact) {
          ctrl.currentContact =
            ctrl.contact instanceof Contact ? ctrl.contact : Contact.build(ctrl.contact);
          ctrl.currentName = ctrl.currentContact.getName();
          ctrl.currentInitials = distillerService.getInitials(ctrl.currentName);
          ctrl.currentAvatar = ctrl.setAvatar(ctrl.currentContact.getAvatar());
          ctrl.currentTip = ctrl.tip !== undefined ? ctrl.tip : ctrl.currentName;
        } else if (ctrl.organization) {
          ctrl.currentOrganization =
            ctrl.organization instanceof Organization
              ? ctrl.organization
              : Organization.build(ctrl.organization);
          ctrl.currentName = ctrl.currentOrganization.getName();
          ctrl.currentInitials = distillerService.getInitials(ctrl.currentName);
          if (ctrl.useEnforcement) {
            if (ctrl.currentOrganization.isRoot()) {
              if (ctrl.useOverride) {
                ctrl.currentAvatar = ctrl.setAvatar(ctrl.currentOrganization.getLogoClient());
              } else {
                ctrl.currentAvatar = ctrl.setAvatar(ctrl.currentOrganization.getLogo());
              }
            } else {
              ctrl.currentAvatar = ctrl.setAvatar(ctrl.currentOrganization.getLogoClient());
            }
          } else {
            ctrl.currentAvatar = ctrl.setAvatar(ctrl.currentOrganization.getLogo());
          }
          ctrl.currentTip = ctrl.tip !== undefined ? ctrl.tip : ctrl.currentName;
        } else {
          ctrl.currentTip = ctrl.tip;
          ctrl.currentAvatar = ctrl.setAvatar(ctrl.avatar);
          ctrl.useTooltip = false;
        }
        if (ctrl.listen) {
          ctrl.destroyWatchAvatar = eventService.onAccountAvatarUploaded(function () {
            if (ctrl.currentAccount) {
              ctrl.currentAvatar = ctrl.setAvatar(ctrl.currentAccount.getAvatar());
            } else if (ctrl.currentContact) {
              ctrl.currentAvatar = ctrl.setAvatar(ctrl.currentContact.getAvatar());
            } else if (ctrl.avatar) {
              ctrl.currentAvatar = ctrl.setAvatar(ctrl.avatar);
            }
          });
          ctrl.destroyWatchLogo = eventService.onOrganizationLogoUploaded(function () {
            if (ctrl.currentOrganization) {
              ctrl.currentAvatar = ctrl.setAvatar(ctrl.currentOrganization.getLogo());
            }
          });
        }
      };

      this.$onChanges = function (changes) {
        if (
          (changes.account && changes.account.currentValue) ||
          (changes.contact && changes.contact.currentValue)
        ) {
          ctrl.$onInit();
        }
      };

      this.$onDestroy = function () {
        if (ctrl.destroyWatchAvatar) {
          ctrl.destroyWatchAvatar();
        }
        if (ctrl.destroyWatchLogo) {
          ctrl.destroyWatchLogo();
        }
      };
    }
  }
};
